<template src="./grid-usuarios.html"></template>
<style lang="less" src="./grid-usuarios.less"></style>

<script>
export default {
  data: function() {
    return {
      headers: [
        {
          text: "Nome",
          align: "left",
          sortable: false,
          value: "nome"
        },
        {
          text: "E-mail",
          align: "left",
          sortable: false,
          value: "email"
        },
        {
          text: "Usuário",
          align: "left",
          sortable: false,
          value: "usuario"
        },
        {
          text: "Ações",
          align: "left",
          sortable: false,
          value: "acoes"
        }
      ],
      grid: null,
      paginaAtual: 1,
      searchQuery: null
    };
  },
  methods: {
    getLista() {
      this.loading = true;
      this.paginaAtual = this.paginaAtual ? this.paginaAtual : 1;
      this.searchQuery = this.searchQuery ? this.searchQuery : null;

      this.$http
        .get(
          "/usuarios?pagina=" +
            this.paginaAtual +
            (this.searchQuery ? "&search=" + this.searchQuery : "")
        )
        .then(result => {
          this.loading = false;
          this.grid = result.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    pageChange(pagina) {
      this.paginaAtual = pagina;
      this.getLista();
    }
  },
  mounted: function() {
    this.getLista();
  }
};
</script>
